// eslint-disable-next-line import/no-named-as-default
import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { FlexColumn, IconButton } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

export const Title = styled(Text)`
    margin: 0;
    white-space: pre-line;
`;

export const Subtitle = styled(Text)`
    margin: 0;

    @media (max-width: 1200px) and (min-width: 880px) {
        width: 242px;
    }
`;

export const ContentContainer = styled(FlexColumn)`
    box-sizing: border-box;
    height: 100%;
    gap: 40px;
`;

export const LeftContentContainer = styled(ContentContainer)`
    padding: 90px 20px 48px 32px;

    @media (max-width: 1200px) and (min-width: 880px) {
        padding-top: 40px;
    }
`;

export const RightContentContainer = styled(ContentContainer)`
    width: 563px;
    background-color: ${colorsPalettes.blue[50]};
    flex-shrink: 0;
    justify-content: center;
    border-radius: 0 8px 8px 0;

    @media (max-width: 930px) {
        width: 546px;
    }
`;

export const CloseButton = styled(IconButton)`
    position: absolute;
    top: 8px;
    left: 8px;
`;
